<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="searchChequeListPayoff(1)">
                    <multiselect v-if="canViewAccounting"
                                 v-model="search.sale_id"
                                 class="form-control select"
                                 placeholder="เซลล์"
                                 :options="sellerList"
                                 :show-labels="false"
                                 label="name"
                                 track-by="name">
                    </multiselect>
                    <multiselect
                        v-model="search.customer_id"
                        class="form-control select"
                        placeholder="ลูกค้า"
                        :options="customers"
                        :show-labels="false"
                        label="store_name"
                        track-by="id">
                    </multiselect>
                    <date-picker
                        v-model="search.date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        class="col-2"
                        range
                        confirm
                        placeholder="วันที่นำฝากเช็ค">
                    </date-picker>
                    <date-picker
                        v-model="search.cheque_p"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        range
                        confirm
                        class="col-2"
                        placeholder="วันที่เช็คตัว P">
                    </date-picker>&nbsp;&nbsp;
                    <b-form-select v-model="search.status"
                                   :options="item_status">
                    </b-form-select>
                    &nbsp;&nbsp;
                    <input type="number" class="form-control col-2"
                           placeholder="หมายเลขเช็ค" v-model="search.ref_no"/>&nbsp;&nbsp;
                    <input type="number" class="form-control col-2"
                           placeholder="จำนวนเงิน" v-model="search.amount"/>&nbsp;&nbsp;
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchChequeListPayoff(1)"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp;&nbsp;
                    <button class="btn btn-primary my-2 my-sm-0"
                            @click="printStatusCheque"
                            type="button">
                        <icon name="print"></icon>
                        พิมพ์รายงานเช็ค
                    </button>
                    &nbsp;&nbsp;
                    <button class="btn btn-info my-2 my-sm-0"
                            @click="showChequeStatus"
                            :disabled="checkbox_id.length < 1"
                            v-if="canViewSuperAdmin || canViewAccounting"
                            type="button">
                        <icon name="redo-alt"></icon>
                        เปลี่ยนสถานะเป็นเช็ค P
                    </button>
                    &nbsp
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered" style="text-align: center">
                <thead>
                <tr>
                    <th scope="col" v-if="canViewSuperAdmin || canViewAccounting">
                        <input type="checkbox" v-model="selectAll"/>
                    </th>
                    <th scope="col">วันที่เช็ค</th>
                    <th scope="col">ประเภทการตัดชำระ</th>
                    <th scope="col">ลูกค้า</th>
                    <th scope="col">เซลล์</th>
                    <th scope="col">ธนาคาร</th>
                    <th scope="col">เลขที่เช็ค</th>
                    <th scope="col">ยอดเงิน</th>
                    <th scope="col">บัญชีปลายทาง</th>
                    <th scope="col" v-if="canViewSuperAdmin || canViewAccounting">สถานะ</th>
                    <th scope="col">วันที่นำเข้าเช็คตัว P</th>
                    <th scope="col">พิมพ์ใบนำฝาก</th>
                    <th scope="col" v-if="canViewSuperAdmin">แก้ไขข้อมูลเช็ค</th>
                    <th scope="col" v-if="canViewSuperAdmin">ลบข้อมูลเช็ค</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in ChequeList">
                    <td v-if="canViewSuperAdmin || canViewAccounting">
                        <input type="checkbox"
                               :value="data"
                               v-model="checkbox_id"/>
                    </td>
                    <td>
                        <template v-if="data.cheque_date">
                            {{ data.cheque_date | moment("DD/MM/YYYY") }}
                        </template>
                    </td>
                    <td>
                        <template v-if="data.payoff_id">
                            <span>ตัดชำระบิลขาย</span>
                        </template>
                        <template v-else-if="data.payoff_other_id">
                            <span>ตัดชำระอื่นๆ</span>
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.customer.length > 0">
                            <span v-for="customer in data.customer">
                                {{ customer.store_name }}<br/>
                            </span>
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.sale">
                            {{ data.sale.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        {{ data.bank }}
                    </td>
                    <td>
                        <template v-if="data.transaction">
                            {{ data.transaction.ref_no }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.transaction">
                            {{ data.transaction.amount | currency }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.bankbook">
                            {{ data.bankbook.account_number }} {{ data.bankbook.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td v-if="canViewSuperAdmin || canViewAccounting">
                        <template v-if="data.status">
                            <template v-if="data.status == 2">
                                <span style="color: #00a699">{{ data.status_name }}</span>
                                &nbsp&nbsp
                            </template>
                            <template v-else>
                                <a style="color: red;text-decoration:underline"
                                   @click="showEditChequeList(data.id)">
                                    {{ data.status_name }}
                                </a>&nbsp&nbsp
                            </template>
                        </template>
                        <template v-else>
                            <a style="color: blue;text-decoration:underline"
                               @click="showEditChequeList(data.id)">
                                รายการรอนำเข้า
                            </a>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.approve_date">
                            {{ data.approve_date | moment("DD/MM/YYYY") }}
                        </template>
                    </td>
                    <td>
                        <button type="button"
                                :disabled="!data.bank_id"
                                @click="printCheque(data.id,data.cheque_bank_id)"
                                class="btn btn-primary">
                            <icon name="print"></icon>
                            พิมพ์
                        </button>
                    </td>
                    <td v-if="canViewSuperAdmin">
                        <button type="button" class="btn btn-info" @click="showEditChequeList(data.id)">
                            <icon name="pencil-alt"></icon>
                            แก้ไข
                        </button>
                    </td>
                    <td v-if="canViewSuperAdmin">
                        <button type="button" class="btn btn-danger" @click="showDeleteChequeList(data.id)">
                            <icon name="trash"></icon>
                            ลบ
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="ChequeList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getChequeListPayoff">
            </vue-pagination>
        </div>
        <br>
        <!-------increment and reduce------>
        <b-modal hide-header hide-footer
                 ref="edit_chequeList">
            <div>
                <edit-cheque-modal @submit="submitData">
                </edit-cheque-modal>
            </div>
        </b-modal>
        <!-------cheque status------>
        <b-modal hide-header hide-footer ref="cheque_status">
            <div>
                <cheque-status-p @submit="hideChequeStatus"/>
            </div>
        </b-modal>
        <b-modal
            ref="delete_item"
            hide-header
            hide-footer>
            <div style="text-align: center;">
                <h4>คุณต้องการลบใช่หรือไม่</h4>
                <br/>
                <button type="button"
                        class="btn btn-success"
                        @click="DeleteCheque()">ตกลง
                </button>
                &nbsp&nbsp
                <button type="button"
                        class="btn btn-secondary"
                        @click="hideDeleteChequeList">ยกเลิก
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker';
import moment from "moment";
import EditChequeModal from "./EditChequeListModal";
import VuePagination from "../../Pagination";
import {domain} from "../../../util/Constants";
import ChequeStatusP from "../../Utility/ChequeStatusP";
import {canSaleView, canViewAccounting, canViewSuperAdmin} from "../../../util/Permissions";

export default {
    components: {
        ChequeStatusP,
        VuePagination,
        EditChequeModal,
        DatePicker,
        Multiselect
    },
    name: "cheque-list",
    data() {
        return {
            customers: [],
            delete_id: '',
            select_all: [],
            checkbox_id: [],
            event_submit: false,
            approve_date: "",
            item_status: [
                {value: "", text: "กรุณาค้นหาสถานะ"},
                {value: 1, text: "B"},
                {value: 2, text: "P"},
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        this.$store.dispatch("ChequeListPayoff/clearSearch");
        if (canViewSuperAdmin() || canViewAccounting()) {
            this.$store.dispatch("ChequeListPayoff/setChequeListPayoff", {page: 1, sale_id: ''});
        } else {
            this.$store.dispatch("ChequeListPayoff/setChequeListPayoff", {page: 1, sale_id: this.user.id});
        }
        this.getCustomerAll();
    },
    computed: {
        canViewSuperAdmin,
        canSaleView,
        canViewAccounting,
        ...mapState({
            ChequeList: state => {
                return state.ChequeListPayoff.ChequeList;
            },
            sellerList: state => {
                return state.Seller.data
            },
            dataPaginate: state => {
                return state.ChequeListPayoff.dataPaginate;
            },
            search: state => {
                return state.ChequeListPayoff.search;
            },
            user: state => {
                return state.Auth.user;
            }
        }),
        selectAll: {
            get: function () {
                return this.ChequeList ? this.checkbox_id.length >= this.ChequeList.length : false;
            },
            set: function (value) {
                if (value) {
                    this.select_all = true;
                    this.checkedAll();
                } else {
                    this.select_all = false;
                    this.checkbox_id = [];
                }
            }
        },
    },
    methods: {
        showEditChequeListModal() {
            this.$refs.edit_chequeList.show();
        },
        hideEditChequeListModal() {
            this.$refs.edit_chequeList.hide();
        },
        showDeleteChequeList(id) {
            this.delete_id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteChequeList() {
            this.$refs.delete_item.hide();
        },
        showEditChequeList(id) {
            this.$store.dispatch('ChequeListPayoff/showChequeListPayoff', id).then(data => {
                this.showEditChequeListModal();
            })
        },
        DeleteCheque() {
            this.$store.dispatch('ChequeListPayoff/deleteChequeListPayoff', this.delete_id).then(() => {
                this.$refs.delete_item.hide();
                this.getChequeListPayoff();
            });
        },
        submitData(submitValue) {
            if (submitValue != 0) {
                let data = {
                    status: submitValue.status,
                    bank_id: submitValue.bank_id,
                    approve_date: submitValue.approve_date ? submitValue.approve_date : moment().format("YYYY-MM-DD"),
                };
                this.$store.dispatch("ChequeListPayoff/saveChequeListPayoff", {
                    id: submitValue.id,
                    data: data
                }).then(() => {
                    let page = this.dataPaginate.current_page;
                    this.searchChequeListPayoff(page);
                    if (canViewSuperAdmin() || canViewAccounting()) {
                        this.$store.dispatch("ChequeListPayoff/setChequeListPayoff", {page: page, sale_id: ''});
                    } else {
                        this.$store.dispatch("ChequeListPayoff/setChequeListPayoff", {
                            page: page,
                            sale_id: this.user.id
                        });
                    }
                    // this.$store.dispatch("ChequeListPayoff/setChequeListPayoff",page)
                });
            }
            this.hideEditChequeListModal();
        },
        searchChequeListPayoff(page) {
            let start_date = "";
            let end_date = "";
            let start_cheque_p = '';
            let end_cheque_p = '';
            this.event_submit = true;
            //change date format
            if (this.search.date.length > 0 && this.search.date[0]) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            } else {
                this.search.date = [];
            }
            if (this.search.cheque_p.length > 0 && this.search.cheque_p[0]) {
                start_cheque_p = moment(this.search.cheque_p[0]).format("YYYY-MM-DD");
                end_cheque_p = moment(this.search.cheque_p[1]).format("YYYY-MM-DD");
            } else {
                this.search.cheque_p = [];
            }
            let sale_id = "";
            let customer_id = "";
            if (this.search.sale_id) {
                sale_id = this.search.sale_id.id;
            }
            if (this.search.customer_id) {
                customer_id = this.search.customer_id.id;
            }
            let current_sale = '';
            if (canViewSuperAdmin() || canViewAccounting()) {
                current_sale = '';
            } else {
                current_sale = this.user.id;
            }
            let data = {
                sale_id: sale_id,
                customer_id: customer_id,
                status: this.search.status,
                start_date,
                end_date,
                start_cheque_p,
                end_cheque_p,
                ref_no: this.search.ref_no,
                amount: this.search.amount,
                current_sale: current_sale
            };
            this.$store.dispatch('ChequeListPayoff/search', {page, data})
        },
        getChequeListPayoff() {
            const page = this.dataPaginate.current_page;
            //paginate search
            if (this.event_submit) {
                this.searchChequeListPayoff(page);
            }
            //paginate get data
            else {
                if (canViewSuperAdmin() || canViewAccounting()) {
                    this.$store.dispatch("ChequeListPayoff/setChequeListPayoff", {page: page, sale_id: ''});
                } else {
                    this.$store.dispatch("ChequeListPayoff/setChequeListPayoff", {page: page, sale_id: this.user.id});
                }
                // this.$store.dispatch('ChequeListPayoff/setChequeListPayoff',page)
            }
        },
        printCheque(id) {
            window.open(domain + "/deposit_cheque/" + id, '_blank');
        },
        printStatusCheque() {
            let start_date = '';
            let end_date = '';
            let start_cheque_p = '';
            let end_cheque_p = '';
            if (this.search.date.length > 0 && this.search.date[0]) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            }
            let sale_id = this.search.sale_id ? this.search.sale_id.id : '';
            let customer_id = this.search.customer_id ? this.search.customer_id.id : '';
            if (this.search.cheque_p.length > 0 && this.search.cheque_p[0]) {
                start_cheque_p = moment(this.search.cheque_p[0]).format("YYYY-MM-DD");
                end_cheque_p = moment(this.search.cheque_p[1]).format("YYYY-MM-DD");
            }
            window.open(`${domain}/cheque_status?status_id=${this.search.status}` +
                `&start_date=${start_date}&end_date=${end_date}` +
                `&start_cheque_p=${start_cheque_p}&end_cheque_p=${end_cheque_p}` +
                `&sale_id=${sale_id}&customer_id=${customer_id}`,
                '_blank');
        },
        getCustomerAll() {
            this.$store.dispatch("Customer/setAllCustomer").then(customers => {
                if (canViewSuperAdmin() || canViewAccounting()) {
                    this.customers = customers;
                } else {
                    this.customers = customers.filter(x =>
                        x.sale_id == this.user.id
                    );
                }
                //console.log(this.customers)
            });
        },
        checkedAll() {
            //change date format
            let start_date = '';
            let end_date = '';
            if (this.search.date.length > 0 && this.search.date[0]) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            } else {
                this.search.date = [];
            }
            let sale_id = "";
            let customer_id = "";
            if (this.search.sale_id) {
                sale_id = this.search.sale_id.id;
            }
            if (this.search.customer_id) {
                customer_id = this.search.customer_id.id;
            }
            let data = {
                sale_id: sale_id,
                customer_id: customer_id,
                status: this.search.status,
                start_date,
                end_date,
            };
            //api checked all
            this.$store.dispatch("ChequeListPayoff/selectAll", data).then(res => {
                this.checkbox_id = res;
            })
        },
        updateStatusCheque() {
            let cheque_id = [];
            if (this.checkbox_id.length > 0) {
                this.checkbox_id.forEach(data => {
                    cheque_id.push(data.id);
                })
            }
            let info = {
                cheque_id: cheque_id,
                approve_date: this.approve_date
            };
            this.$store.dispatch("ChequeListPayoff/updateChequeStatus", info).then(() => {
                alert("อัพเดตสถานะเช็คเป็น P ทั้งหมด สำเร็จ");
                // this.$store.dispatch("ChequeListPayoff/setChequeListPayoff");
                if (canViewSuperAdmin() || canViewAccounting()) {
                    this.$store.dispatch("ChequeListPayoff/setChequeListPayoff", {page: 1, sale_id: ''});
                } else {
                    this.$store.dispatch("ChequeListPayoff/setChequeListPayoff", {page: 1, sale_id: this.user.id});
                }
                this.checkbox_id = [];
            }).catch(err => {
                alert("อัพเดตสถานะเช็คเป็น P ทั้งหมด ไม่สำเร็จ");
            });
        },
        showChequeStatus() {
            this.$refs.cheque_status.show();
        },
        hideChequeStatus(value) {
            if (value) {
                this.approve_date = value;
                this.updateStatusCheque();
            }
            this.$refs.cheque_status.hide();
        }

    }
}
</script>

<style lang="scss" scoped>
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
    color: black;
    font-weight: bold;
    background-color: #FCD61B;
    border-radius: 10px;
}

.margin {
    margin: 5px;
}

.navbar-nav .nav-link {
    color: black;
}

.select {
    border: 0px
}
</style>
